import React from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { SIDE_NAV_WIDTH } from 'constants/ThemeConstant';
import { Scrollbars } from 'react-custom-scrollbars';
import { ReduxState } from '../../redux/reducers';

const { Sider } = Layout;

interface SideNavProps {
  navCollapsed: boolean;
  menuContent: React.ReactNode;
}

export const SideNav = ({ navCollapsed, menuContent }: SideNavProps) => {
  return (
    <Sider className="side-nav" width={SIDE_NAV_WIDTH} collapsed={navCollapsed}>
      <Scrollbars autoHide>
        <div style={{ overflowX: 'hidden' }}>{menuContent}</div>
      </Scrollbars>
    </Sider>
  );
};

const mapStateToProps = ({ theme }: ReduxState) => {
  const { navCollapsed } = theme;
  return { navCollapsed };
};

export default connect(mapStateToProps)(SideNav);
